<!-- Navigation -->
<nav class="navbar navbar-expand-lg navbar-light bg-transparent py-3 absolute">
  <div class="container">
      <span _ngcontent-pwg-c0=""><img _ngcontent-pwg-c0="" alt="" height="72" src="assets/img/icbeu.png"></span>
    <button class="navbar-toggler navbar-toggler-right text-white btn-fill" type="button" data-toggle="collapse"
      data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false"
      aria-label="Toggle navigation" routerLink="/login">
      Fazer Login
    </button>
    <div class="collapse navbar-collapse">
      <ul class="navbar-nav ml-auto my-2 my-lg-0">
        <li class="nav-item">
          <a class="nav-link text-white" routerLink="/register">Quero ser aluno</a>
        </li>
        <li class="nav-item">
          <a class="btn btn-danger btn-fill" routerLink="/login">Fazer Login</a>
        </li>
      </ul>
    </div>
  </div>
</nav>

<div class="section section-header">
  <div class="parallax filter">
    <div class="image" style="background-image: url('assets/img/United-States-Flag.jpg') center;">
      <video id="video_background" preload="auto" autoplay="true" loop="loop" muted="muted" volume="0">
        <source src="assets/img/United-States-Flag.mp4" type="video/webm">
        <source src="assets/img/United-States-Flag.mp4" type="video/mp4">
        Video not supported
      </video>
    </div>
    <div class="container-site">
      <div class="content">
        <div class="title-area">
            <span _ngcontent-pwg-c0=""><img _ngcontent-pwg-c0="" alt="icbeu-logo" height="272" src="assets/img/icbeu.png"></span>
          <h3>Se você ainda não é aluno ICBEU, confira as vantagens em estudar conosco</h3>
          <div class="separator line-separator">♦</div>
        </div>

        <div class="button-get-started">
          <a routerLink="/register" class="btn btn-white btn-fill btn-lg ">
            Quero ser aluno
          </a>
        </div>
      </div>

    </div>
  </div>
</div>


<div class="section">
  <div class="container">
    <div class="row">
      <div class="title-area">
        <h2>Por que estudar no ICBEU ?</h2>
        <div class="separator separator-danger">✻</div>
        <p class="description">
          Porque o Instituto Cultural Brasil - Estados Unidos é a única instituição reconhecida pela Embaixada Americana
          como Centro Binacional (BNC) de excelência no Amazonas.
          Abaixo algumas das vantagens em ser ICBEU:
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="info-icon">
          <div class="icon text-danger">
            <i class="pe-7s-graph1"></i>
          </div>
          <h3>Metodologia</h3>
          <p class="description">
            Adotamos a Abordagem Comunicativa (Communicative Language Teaching/CLT) como filosofia de ensino.
          </p>
        </div>
      </div>
      <div class="col-md-3">
        <div class="info-icon">
          <div class="icon text-danger">
            <i class="pe-7s-network"></i>
          </div>
          <h3>MakerSpace</h3>
          <p class="description">
            Espaço para aulas práticas, tanto para alunos como para a comunidade nas mais diversas áreas.
          </p>
        </div>
      </div>
      <div class="col-md-3">
        <div class="info-icon">
          <div class="icon text-danger">
            <i class="pe-7s-study"></i>
          </div>
          <h3>Curso Kinder</h3>
          <p class="description">
            Temos o melhor curso para crianças de 3 a 6 anos com um espaço totalmente preparado, moderno e ótimos
            professores.
          </p>
        </div>
      </div>
      <div class="col-md-3">
        <div class="info-icon">
          <div class="icon text-danger">
            <i class="pe-7s-notebook"></i>
          </div>
          <h3>Biblioteca</h3>
          <p class="description">
            Com acervo constantemente atualizado, equipamentos de última geração, mesas e áreas de descanso, leitura.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="section section-our-team-freebie">
  <div class="parallax filter filter-color-black">
    <div class="image" style="background-image:url('assets/img/classroom-2787754_640.jpg')">
      <particles [params]="paramsParticles" [style]="styleParticles"></particles>
    </div>
    <div class="container container-site">
      <div class="content">
        <div class="row">
          <div class="title-area">
            <h2>Nossos Professores</h2>
            <div class="separator separator-danger">✻</div>
            <p class="description">Os professores ICBEU são capacitados com treinamentos, palestras, eventos para que as
              aulas
              sejam ministradas cada vez com mais qualidade.</p>

            <div class="align-content-center">
              <button class="previous btn btn-white btn-fill teacher-slider-prev"  (click)="loadListTeacher()"> <i class="fas fa-backward"></i> Anterior </button>

              <button class="next btn btn-white btn-fill teacher-slider-nex"(click)="loadListTeacher()">Próximo <i class="fas fa-forward"></i>  </button>
            </div>
          </div>

        </div>

        <div class="team">

          <div class="row">
            <div class="col-md-12 ">
              <div class="row">
                <div class="col-md-4" *ngFor="let p of teacher">

                  <div class="card card-member h-100 mt-1">
                    <div class="content">
                      <div class="avatar-site avatar-site-danger">
                        <img 
                          class="img-circle" 
                          [src]="p.urlImage"
                          style="height: 110px!important;width: 100%!important;" 
                        >
                      </div>
                      <div class="description">
                        <h3 class="title">{{ p.nome_professor }}</h3>
                        <p class="card-text-bolder text-lowercase">{{ p.email }}</p>
                        <p class="description">{{ p.texto_apresentacao }}</p>
                      
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="section section-our-clients-freebie">
  <div class="container">
    <div class="title-area">
      <h5 class="subtitle text-gray">Eles se formaram no ICBEU</h5>
      <h2>Depoimentos dos nossos alunos</h2>
      <div class="separator separator-danger">∎</div>
    </div>

    <div class="team">
      <div class="row">
        <div class="col-md-12 ">
          <div class="row">
            <div class="col-md-4">
              <div class="card card-member border-0" style="box-shadow: none!important;">
                <div class="content">
                  <div class="avatar-site avatar-site-danger">
                    <img alt="..." class="img-circle"
                      style="height: 110px!important;width: 100%!important;" 
                      src="assets/img/giovanna_conte.jpg" />
                  </div>
                  <div class="description">
                    <h3 class="title">Giovanna Donadio Conte</h3>
                    <p class="small-text">Student</p>
                    <p class="description font-italic">“O ICBEU teve uma grande contribuição em minha vida, um instituto
                      tradicional, comprometido em
                      oferecer um ensino de qualidade, onde pude fazer grandes amizades. Faça parte dessa família você
                      também, We are ICBEU!”</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card card-member border-0" style="box-shadow: none!important;">
                <div class="content">
                  <div class="avatar-site avatar-site-danger">
                    <img alt="..." class="img-circle"
                      style="height: 110px!important;width: 100%!important;" 
                      src="assets/img/lennon_chaves.jpg" />
                  </div>
                  <div class="description">
                    <h3 class="title">Lennon Chaves</h3>
                    <p class="small-text">Student</p>
                    <p class="description font-italic">“Aprender outro idioma é essencial hoje em dia, e o ICBEU me
                      ajudou bastante como aluno.
                      Sempre tive muita vontade de estudar no ICBEU, pois me falavam que era um ótimo instituto para
                      estudar. Graças ao
                      incentivo dos professores (que são ótimos e muito competentes) e a plataforma de aprendizado que a
                      escola oferece, só tenho a
                      agradecer todas as lições e ensinamentos aprendidos. Posso dizer que estudar no ICBEU foi a
                      escolha certa.”</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card card-member border-0" style="box-shadow: none!important;">
                <div class="content">
                  <div class="avatar-site avatar-site-danger">
                    <img alt="..." class="img-circle"
                      style="height: 110px!important;width: 100%!important;" 
                      src="assets/img/jose_coutinho.jpg" />
                  </div>
                  <div class="description">
                    <h3 class="title">José Lucas Freire Coutinho</h3>
                    <p class="small-text">Student</p>
                    <p class="description font-italic">“Minha experiência no ICBEU foi incrível! É um pedacinho da
                      América sem sair de Manaus. Aprender inglês e
                      fazer amigos ao mesmo tempo, pra mim foi fantástico. Sou muito grato pela receptividade da
                      escola!.”</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>


<div class="section section-small section-get-started">
  <div class="parallax filter">
    <div class="image" style="background-image: url('assets/img/learning-3245793_640.jpg')">
      <particles [params]="paramsParticles" [style]="styleParticles"></particles>
    </div>
    <div class="container-site">
      <div class="title-area">
        <h2 class="text-white">Quer se tornar aluno ICBEU?</h2>
        <div class="separator line-separator">♦</div>
        <p class="description"> Para mais informações, clique no botão abaixo</p>
      </div>

      <div class="button-get-started">
        <a routerLink="/register" class="btn btn-danger btn-fill btn-lg">Quero saber mais</a>
      </div>
    </div>
  </div>
</div>


<footer class="footer footer-big footer-color-black" data-color="black">
  <div class="container">
    <div class="row">
      <div class="col-md-2 col-sm-3">
        <div class="info">
          <h5 class="title">O ICBEU</h5>
          <nav>
            <ul>
              <li>
                <a href="http://icbeu.com/">Home</a></li>
              <li>
                <a href="http://icbeu.com/quem-somos/">Quem somos</a>
              </li>
              <li>
                <a href="http://icbeu.com/cursos/">Cursos</a>
              </li>
              <li>
                <a href="http://icbeu.com/conheca-o-icbeu/">Conheça o ICBEU</a>
              </li>
              <li>
                <a href="http://icbeu.com/faq/">FAQ</a>
              </li>
              <li>
                <a href="http://icbeu.com/convenios-e-parcerias/">Convênios e Parcerias</a>
              </li>
              <li>
                <a href="http://icbeu.com/contrato-e-regulamento/">Contrato e Regulamento</a>
              </li>
              <li>
                <a href="http://icbeu.com/resultados-e-informacoes/">Resultados e Informações</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div class="col-md-3 col-md-offset-1 col-sm-3">
        <div class="info">
          <h5 class="title"> DIFERENCIAL</h5>
          <nav>
            <ul>
              <li>
                <a href="http://icbeu.com/metodologia/">Metodologia</a>
              </li>
              <li>
                <a href="https://www.instagram.com/makerspaceicbeumanaus/">MakerSpace</a>
              </li>
              <li>
                <a href="http://icbeu.com/biblioteca/">Biblioteca</a>
              </li>
              <li>
                <a href="http://icbeu.com/coral/">Coral</a>
              </li>
              <li>
                <a href="http://icbeu.com/certificacoes/">Certificações</a>
              </li>
              <li>
                <a href="http://icbeu.com/bons-motivos/">Bons Motivos</a>
              </li>
              <li>
                <a href="http://icbeu.com/educationusa/">Education USA</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div class="col-md-3 col-sm-3">
        <div class="info">
          <h5 class="title">Blog</h5>
          <nav>
            <ul>
              <li>
                <a href="http://icbeu.com/2019/01/16/makerspace/#sthash.lRXbmtmu.dpbs">
                  <b>Makerspace</b> Saiba tudo sobre esse espaço...
                  <hr class="hr-small">
                </a>
              </li>
              <li>
                <a href="http://icbeu.com/2019/01/09/curso-anytime/#sthash.nHyBi9CW.dpbs">
                  Saiba tudo sobre o <b> Curso Anytime</b>...
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div class="col-md-2 col-md-offset-1 col-sm-3">
        <div class="info">
          <h5 class="title">Siga-nos:</h5>
          <nav>
            <ul>
              <li>
                <a href="https://www.facebook.com/icbeumanaus/" class="btn btn-social btn-primary btn-simple">
                  <i class="fab fa-facebook-square"></i> Facebook
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/icbeumanaus/" class="btn btn-social btn-dribbble btn-simple">
                  <i class="fab fa-instagram"></i> instagram
                </a>
              </li>
              <li>
                <a href="https://twitter.com/ICBEUManaus" class="btn btn-social btn-twitter btn-simple">
                  <i class="fab fa-twitter"></i> Twitter
                </a>
              </li>
              <li>
                <a href="https://www.youtube.com/channel/UCz5LxQyOJjISlxvBv7XC-hQ"
                  class="btn btn-social btn-reddit btn-simple">
                  <i class="fab fa-youtube"></i> Youtube
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
    <hr>
    <div class="copyright">
      © 2019 ICBEU Manaus
    </div>
  </div>
</footer>
